module.exports = __webpack_public_path__ + "static/media/tag-cone-full.dde9202e.svg";